/** Permission bits. Mirrored in apps/server/migrations/0001_init.sql (default roles). */
export const Permission = {
    READ_ISSUE: 1n << 0n,
    CREATE_ISSUE: 1n << 1n,
    UPDATE_ISSUE: 1n << 2n,
    DELETE_ISSUE: 1n << 3n,
    ADD_COMMENT: 1n << 4n,
    UPDATE_PROJECT: 1n << 5n,
    MANAGE_MEMBERS: 1n << 6n,
    READ_PRIVATE: 1n << 7n,
    // M11: Knowledge Base (YouTrack's four article permissions).
    READ_ARTICLE: 1n << 8n,
    CREATE_ARTICLE: 1n << 9n,
    UPDATE_ARTICLE: 1n << 10n,
    DELETE_ARTICLE: 1n << 11n,
};
export const has = (bits, p) => (bits & p) === p;
/** Every bit with the label the Roles page shows; order is display order. */
export const PERMISSION_INFO = [
    { key: "READ_ISSUE", label: "Read issues", group: "Issues" },
    { key: "CREATE_ISSUE", label: "Create issues", group: "Issues" },
    { key: "UPDATE_ISSUE", label: "Update issues", group: "Issues" },
    { key: "DELETE_ISSUE", label: "Delete issues", group: "Issues" },
    { key: "ADD_COMMENT", label: "Add comments", group: "Issues" },
    { key: "READ_PRIVATE", label: "Read restricted issues, comments and articles", group: "Issues" },
    { key: "UPDATE_PROJECT", label: "Update project (settings, fields, workflows)", group: "Project" },
    { key: "MANAGE_MEMBERS", label: "Manage roles in the project", group: "Project" },
    { key: "READ_ARTICLE", label: "Read articles", group: "Knowledge Base" },
    { key: "CREATE_ARTICLE", label: "Create articles", group: "Knowledge Base" },
    { key: "UPDATE_ARTICLE", label: "Update articles", group: "Knowledge Base" },
    { key: "DELETE_ARTICLE", label: "Delete articles", group: "Knowledge Base" },
];
/** OR of every defined bit. */
export const ALL_PERMISSION_BITS = Object.values(Permission).reduce((a, b) => a | b, 0n);
//# sourceMappingURL=perm.js.map